
import { api_host,api_auth} from '../../common/globals/constants';

export const getHoursList = (user, token, type) => 
fetch(api_host+`/reporte/general/horarios_habiles/?token=${token}&user=${user}&type=${type}`)
.then(response => response.json())
